module.exports = __webpack_public_path__ + "img/211.a799df2f.png";